import OrderBumpSteps     from './blocks/OrderBumpSteps';
import OrderBumpOfferForm from './blocks/OrderBumpOfferForm';

const orderBumpStepsBlock = new OrderBumpSteps();
orderBumpStepsBlock.register();

const orderBumpOfferFormBlock = new OrderBumpOfferForm();
orderBumpOfferFormBlock.register();
